import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { useSelector } from "react-redux";
import { PiCheckCircleBold } from "react-icons/pi";
import { IconButton, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { IoMdCloseCircleOutline } from "react-icons/io";

export default function FeedbackCompletedModal({}) {
  const navigate = useNavigate();
  const { showModal } = useSelector((state) => state.commonReducer);

  const handleClose = () => {
    // dispatch({
    //   type: commonActions.SET_SHOW_MODAL,
    //   payload: { show: false, type: null, method: null, data: null },
    // });
    Cookies.remove("test_engine_token");
    Cookies.remove("test_engine_project");
    navigate(`/thank-you`);
  };

  return (
    <>
      <Dialog
        minWidth="sx"
        open={showModal?.show && showModal?.method === "B"}
        onClose={handleClose}
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
            padding:'24px'
          },
        }}
      >
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            pb: 3,
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              color: "#000",
            }}
          >
            <IoMdCloseCircleOutline />
          </IconButton>
          <PiCheckCircleBold size={45} style={{ color: "#4BB543" }} />
          <Typography sx={{ fontSize: 18, fontWeight: 500 }}>
            Feedback completed
          </Typography>
        </DialogContent>
        {/* <DialogActions style={{ pt: 0 }}>
          <Button onClick={handleClose} autoFocus>
            Close
          </Button>
        </DialogActions> */}
      </Dialog>
    </>
  );
}
